<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SiteFormPage from '@/views/apps/sites/SiteFormPage.vue'

const sitesPageMeta = PageMeta.Sites as unknown as {
  Add: { Meta: Record<string, unknown>; Title: string }
}

definePage({ meta: PageMeta.Sites.Add.Meta })
setPageTitle(sitesPageMeta.Add.Title)
</script>

<template>
  <SiteFormPage mode="create" />
</template>
